<template>
	<div class="container">
		<b-card>
			<b-row align-v="end">
				<b-col class="col-md-6">
					<label for="">Escolha o Arquivo para Importação</label>
					<input type="file" class="form-control" @change='changeFile'>
				</b-col>
				<b-col class="col-md-3">
					<button class="btn btn-primary" @click="sendFile" style=" margin-top: 1.6em;"> <i
							class="fa fa-send"></i> Processar Arquivo</button>
				</b-col>
				<b-col v-if="pedidosComErros === 0" class="col-md-3">
					<button class="btn btn-larger btn-success" :disabled="!pedidos.length" @click.prevent="sendPedidos"><i
							class="fa fa-save"></i> ENVIAR PEDIDOS </button>
				</b-col>
			</b-row>		
			
			<div v-if="pedidosComErros > 0">
				<h2 class="text-danger">Há {{ pedidosComErros }} pedido (s) com erros. Por favor, verifique e tente novamente.
				</h2>
			</div>
			<div class="row" v-for="(pedido, i) in pedidos" :key="i">
				<div class="col-md-12">
					<div class="row">
						<div class="card">
							<div class="card-body">
								<div class="row" v-if="pedido.erros.length > 0" role="alert">
									<div class="col-md-12">
										<div class="alert alert-danger">
											<strong>Erros encontrados:</strong>
											<ul>
												<li v-for="(erro, e) in pedido.erros" :key="e">
													{{ erro }}
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-md-6">
										<div class="row">
											<legend>Revendedora <small
													class="text-primary">({{ (pedido.revendedoras_existe) ? "Atualizar" :
														"Cadastrar" }}):</small></legend>

											<div class="col-md-8">
												<strong>Nome: </strong> {{ pedido.revendedora.nome }}
											</div>

											<div class="col-md-4">
												<strong>CPF: </strong> {{ pedido.revendedora.cpf }}
											</div>
											<div class="col-md-4">
												<strong>RG: </strong> {{ pedido.revendedora.rg }}
											</div>
											<div class="col-md-4">
												<strong>Data Nasc: </strong> {{ pedido.revendedora.data_nasc }}
											</div>
											<div class="col-md-4">
												<strong>Email: </strong> {{ pedido.revendedora.email }}
											</div>
										</div>
									</div>
									<div class="col-md-6">
										<div class="row">
											<legend>Endereço:</legend>
											<div class="col-md-4">
												<strong>CEP: </strong> {{ pedido.revendedora.cep }}
											</div>
											<div class="col-md-8">
												<strong>Logradouro: </strong> {{ pedido.revendedora.logradouro }}
											</div>
											<div class="col-md-4">
												<strong>Bairro: </strong> {{ pedido.revendedora.bairro }}
											</div>
											<div class="col-md-4">
												<strong>Complemento: </strong> {{ pedido.revendedora.bairro.complemento }}
											</div>
											<div class="col-md-4">
												<strong>Cidade: </strong> {{ pedido.revendedora.nome_cidade }}
												-
												{{ pedido.revendedora.estado }}
											</div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-md-12">
										<h3>Itens do Pedido</h3>
										<table class="table-hover table-striped table-bordered" width='100%'>
											<thead>
												<tr class="text-primary">
													<th class="text-center">Código</th>
													<th>Produto</th>
													<th class="text-center">Quantidade</th>
													<th class="text-center">Total</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(item, z) in pedido.itens"
													:class="{ 'bg-primary': !existeProduto(item.codigo) }" :key="z">
													<td class="text-center">{{ item.codigo }}</td>
													<td>{{ getProduto(item.codigo) }}</td>
													<td class="text-center">{{ item.quantidade }}</td>
													<td class="text-center">R$ {{ calcPreco(item.codigo, item.quantidade) }}
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-card>
	</div>
</template>


<script>

export default {
	props: [],
	data() {
		return {
			arquivo: null,
			produtos: {},
			pedidos: [],
		}
	},
	methods: {
		sendFile() {
			if (this.arquivo == null) {
				this.$swal("OPS", "Selecione o Arquivo", 'error');
				return;
			}

			var form = new FormData();

			form.append('pedidos', this.arquivo);
			var vm = this;
			$('.loading').show();
			axios.post('/distribuidor/importacao/pedidos/interpretar', form).then((response) => {
				vm.pedidos = response.data;
				$('.loading').hide();
			}).catch(function (error) {
				alert("Falha na Importação\n Por favor, Tente novamente ou entre em contato como o suporte.");
				console.log(error);
				$('.loading').hide();

			});
		},
		sendPedidos() {
			var pedidosParaEnviar = this.getPeditosFormatadosParaEnvio();

			if (this.pedidosComErros > 0) {
				alert("Por Favor, verifique os pedidos com Erros ");
				return;
			} else if (pedidosParaEnviar.length === 0) {
				alert("Não há Pedidos com Itens para envio");
				return;
			}

			$('.loading').show();

			axios.post('/distribuidor/importacao/pedidos',
				{
					"pedidos": pedidosParaEnviar,
					"origem": 'IMPORTAÇÃO'
				})
				.then((response) => {
					window.location = "/distribuidor/pedidos?status=ABERTO";

				}).catch((error) => {
					console.log(error);
					alert("Falha na importação dos Pedidos");
					$('.loading').hide();
				});
		},
		LoadProdutos: function () {
			$('.loading').show();
			var vm = this;
			axios.get('/distribuidor/produtos/list').then(function (response) {
				let produtos = response.data;
				produtos.forEach(function (produto) {

					vm.produtos["" + parseInt(produto.codigo)] = { id: produto.id, codigo: produto.codigo, nome: produto.nome, preco: produto.pivot.preco };
				});
				$('.loading').hide();
			}).catch(function (error) {
				alert("Erro ao carregar Produtos");
				console.log(error);
				$('.loading').hide();
			});
		},
		changeFile(e) {
			this.arquivo = null;
			let files = e.target.files || e.dataTransfer.files;
			if (!files.length)
				return;

			if (!this.validateExtension(files[0])) {

				return;
			}

			this.arquivo = files[0];

		},
		validateExtension(file) {
			if (!file.name.match(/\.(csv|txt)$/i)) {
				alert('Anexe um arquivo CSV ou TXT');
				return false;
			}
			return true;
		},
		getProduto(codigo) {
			if (this.existeProduto(codigo)) {
				return this.produtos[codigo].nome;
			}

			return "PRODUTO NÃO ENCONTRADO";
		},
		existeProduto(codigo) {
			return typeof (this.produtos[codigo]) !== 'undefined';
		},
		calcPreco(produto, quantidade) {

			if (this.existeProduto(produto)) {
				let total = parseFloat(this.produtos[produto].preco) * parseInt(quantidade);
				return total.toFixed(2).replace('.', ',');
			}

			return 0;
		},
		getPeditosFormatadosParaEnvio() {
			var vm = this;
			var pediosPraEnviar = [];
			this.pedidos.forEach(function (pedido, index) {
				if (pedido.erros.length === 0) {
					let itens = vm.getItensValidos(pedido.itens);
					if (itens.length > 0) {
						let pedidoLocal = {
							revendedora: pedido.revendedora,
							itens: itens
						};
						pediosPraEnviar.push(pedidoLocal);
					}
				}
			});
			return pediosPraEnviar;
		},
		getItensValidos(itens) {
			var itensValidos = [];
			var vm = this;
			itens.forEach(function (item, index) {
				if (vm.existeProduto(item.codigo)) {
					itensValidos.push(item);
				}
			});
			return itensValidos;
		}
	},
	computed: {
		qtdPedidosValidos() {
			var total = 0;	
			this.pedidos.forEach((pedido, index) => {
				if (pedido.erros.length === 0) {
					total++;
				}
			});
			return total;
		},
		pedidosComErros() {
			var total = 0;
			this.pedidos.forEach((pedido, index) => {
				if (pedido.erros.length > 0) {
					total++;
				}
			});
			return total;
		}
	},
	mounted() {
		this.LoadProdutos();
	}
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/distribuidor_importar_pedidos/Main.vue